<script>
	const util = require('../utilities');
	const accountService = require('services/accountService');
	const userContext = require('core/userContext');
	const model = require('model/model');
	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'form-submitter': require('components/form-submitter.vue').default
		},
		props: {
			'modal-title': {
				default: 'Set Email',
				type: String
			},
			'min-length': {
				required: false,
				default: 8,
				type: Number
			},
			'max-length': {
				required: false,
				default: 64,
				type: Number
			},
			'button-text': {
				type: String,
				default: 'Set Email'
			},
			'extra-data': {
				required: false,
				type: Object,
				default: null
			},
			'modal-id': {
				default: 'modal-change-email',
				type: String
			},
			'prompt-for-current': {
				type: Boolean,
				default: false
			},
			'validation-off': {
				type: Boolean,
				default: false
			},
			'visible-email': {
				type: Boolean,
				default: false
			},
			confirm: {
				type: Boolean,
				default: false
			}
		},
		data: function () {
			return {
				modalEmailForm: {
					email: ''
				}
			};
		},
		mounted() {
			var self = this;

			self.$watch(
				'promptForCurrent',
				function (p) {
					if (p) {
						self.modalEmailForm.currentEmail = '';
					}
				},
				{
					immediate: true
				}
			);

			pubsub.subscribe('before-submit', function (evData) {
				if (evData.formName !== 'modalEmailForm') {
					return true;
				}

				self.modalEmailForm = $.extend(true, {}, self.modalEmailForm, self.extraData || {});

				return true;
			});

			pubsub.subscribe('submit-succeeded', function (evData) {
				if (evData.formName !== 'modalEmailForm') {
					return true;
				}
				util.closeModals();
				// reset data so the dialog can be reused
				self.modalEmailForm.email = '';
				if (self.promptForCurrent) {
					self.modalEmailForm.currentEmail = '';
				}
				pubsub.publish('message-success', 'Changed email address');

				return true;
			});
		},
		methods: {
			changeEmail: function (data) {
				return accountService.teacherChangeUsername(data).then(function (result) {
					var existing = userContext.getUserData();

					existing.token = result.token;
					existing.email = data.email;

					model.set('userContext', existing);
				});
			}
		}
	};
</script>
<template>
	<div
		v-bind:id="modalId"
		class="modal"
		data-modal-window>
		<div class="modal-container">
			<div class="modal-window">
				<div class="modal-window-wrap">
					<button
						class="modal-close"
						data-modal-close>
						<span aria-hidden="true">&times;</span><span class="hidden-visually"> Close</span>
					</button>
					<section class="modal-content">
						<header class="modal-content-header">
							<h2>{{ modalTitle }}</h2>
						</header>
						<div class="modal-content-main -form">
							<form-submitter
								form-name="modalEmailForm"
								:form-data.sync="modalEmailForm"
								:submit-to="changeEmail"
								class="form"
								novalidate>
								<auto-form-row
									v-bind:visible-email="visibleEmail"
									v-bind:type="confirm ? 'confirmedEmail' : 'email'"
									row-class="label-hidden-visually"
									v-bind:min-length="minLength"
									v-bind:max-length="maxLength"
									v-bind:data.sync="modalEmailForm.email"
									v-bind:placeholder="confirm ? 'New Email|Confirm New Email' : 'New Email'"
									v-bind:novalidate="validationOff"
									required>
								</auto-form-row>
								<auto-form-row
									row-class="-full-width"
									v-bind:all-valid="modalEmailForm.allValid"
									type="submit">
									{{ buttonText }}
								</auto-form-row>
							</form-submitter>
						</div>
					</section>
				</div>
			</div>
		</div>
	</div>
	<!-- end #modal-change-email -->
</template>
